module.exports = __webpack_public_path__ + "img/scooltools--logo--en.9060e4a3.jpg";